var NativeInterfaceAbstractCommunication = /** @class */ (function () {
    function NativeInterfaceAbstractCommunication(eventRouter) {
        this.requestPromises = {};
        this.requestPromisesResolve = {};
        this.requestPromisesReject = {};
        this.requestPromisesTimeout = {};
        this.requestId = 0;
        this.eventRouter = eventRouter;
    }
    NativeInterfaceAbstractCommunication.prototype.onCommunicationReceived = function (event) {
        if (typeof this.requestPromises[event.id] !== 'undefined' && this.requestPromises[event.id] !== null) {
            try {
                if (typeof event.error !== 'undefined') {
                    this.requestPromisesReject[event.id](event.error);
                }
                else {
                    this.requestPromisesResolve[event.id](event.result);
                }
            }
            catch (e) {
                console.error(e);
            }
            delete this.requestPromises[event.id];
            delete this.requestPromisesReject[event.id];
            delete this.requestPromisesResolve[event.id];
            if (typeof this.requestPromisesTimeout[event.id] !== 'undefined' && this.requestPromisesTimeout[event.id] !== null) {
                clearTimeout(this.requestPromisesTimeout[event.id]);
                delete this.requestPromisesTimeout[event.id];
            }
        }
        else if (event.id === -1) { //notification/auto generated event
            this.eventRouter({ name: event.name, data: event.data });
        }
    };
    NativeInterfaceAbstractCommunication.prototype.request = function (event, timeout) {
        if (timeout === void 0) { timeout = 10 * 1000; }
        var rid = this.requestId++;
        var self = this;
        if (timeout > 0) {
            this.requestPromisesTimeout[rid] = setTimeout(function () {
                if (typeof self.requestPromisesTimeout[rid] !== 'undefined' && self.requestPromisesTimeout[rid] !== null) {
                    self.requestPromisesReject[rid]({ error: 'native_timeout', request: event });
                    delete self.requestPromises[rid];
                    delete self.requestPromisesReject[rid];
                    delete self.requestPromisesResolve[rid];
                    delete self.requestPromisesTimeout[rid];
                }
            }, timeout);
        }
        this.requestPromises[rid] = new Promise(function (resolve, reject) {
            self.requestPromisesResolve[rid] = resolve;
            self.requestPromisesReject[rid] = reject;
            // we execute the call function which can takes time in another "thread" (detached form the current/ set at the end of the js execution pile)
            // if the call was triggered by a click it will prevent to block the UI
            setTimeout(function () {
                var status = self.call({
                    name: event.name,
                    params: event.params,
                    id: rid
                });
                if (!status) {
                    self.onCommunicationReceived({ name: event.name, id: rid, error: 'non_native_platform' });
                }
                else {
                }
            }, 0);
        });
        return this.requestPromises[rid];
    };
    return NativeInterfaceAbstractCommunication;
}());
export { NativeInterfaceAbstractCommunication };
//# sourceMappingURL=NativeInterfaceAbstractCommunication.js.map